import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import type { CaseSearchItem } from '@/lib/queries/business/types'

import { Content } from './content/content'

export interface EditCaseDialogProps {
  open: boolean
  applicantId: string
  aCase: CaseSearchItem
  onClose: () => void
}

export const EditCaseDialog: React.FC<EditCaseDialogProps> = ({ open, applicantId, aCase, onClose }) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose()
        }
      }}
    >
      <DialogContent
        onPointerDownOutside={(e) => {
          e.preventDefault()
        }}
      >
        <DialogHeader className="mb-5">
          <DialogTitle>Edit Case</DialogTitle>
          <DialogDescription>This dialog is for editing the case information.</DialogDescription>
        </DialogHeader>

        <Content applicantId={applicantId} aCase={aCase} onClose={onClose} />
      </DialogContent>
    </Dialog>
  )
}
